"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updatePagesForSitemapIndex = exports.changeSitemapPageForEdit = exports.updateFilterForSitemap = exports.updateDomainForSitemap = exports.updateEditPageUrlsTableIndex = exports.updatePageForUrlEdit = exports.closeEditPageUrls = exports.openEditPageUrlsTable = exports.openEditPageUrls = exports.updateDomainForLanguageEdit = exports.InteractionsActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _UrlPathParams = require("settings-ui-sdk/constants/UrlPathParams");

var InteractionsActionTypes = (0, _namespacedKeyMirror.default)({
  UPDATE_DOMAIN_FOR_LANGUAGE_EDIT: null,
  OPEN_EDIT_PAGE_URLS: null,
  OPEN_EDIT_PAGE_URLS_TABLE: null,
  CLOSE_EDIT_PAGE_URLS: null,
  UPDATE_PAGE_FOR_URL_EDIT: null,
  UPDATE_EDIT_PAGE_URLS_TABLE_INDEX: null,
  UPDATE_DOMAIN_FOR_SITEMAP: null,
  UPDATE_FILTER_FOR_SITEMAP: null,
  CHANGE_SITEMAP_PAGE_FOR_EDIT: null,
  UPDATE_PAGES_FOR_SITEMAP_INDEX: null
}, _UrlPathParams.DOMAINS);
exports.InteractionsActionTypes = InteractionsActionTypes;
var updateDomainForLanguageEdit = (0, _fluxActions.createAction)(InteractionsActionTypes.UPDATE_DOMAIN_FOR_LANGUAGE_EDIT, function (domain) {
  return domain;
});
exports.updateDomainForLanguageEdit = updateDomainForLanguageEdit;
var openEditPageUrls = (0, _fluxActions.createAction)(InteractionsActionTypes.OPEN_EDIT_PAGE_URLS, function (config) {
  return config;
});
exports.openEditPageUrls = openEditPageUrls;
var openEditPageUrlsTable = (0, _fluxActions.createAction)(InteractionsActionTypes.OPEN_EDIT_PAGE_URLS_TABLE);
exports.openEditPageUrlsTable = openEditPageUrlsTable;
var closeEditPageUrls = (0, _fluxActions.createAction)(InteractionsActionTypes.CLOSE_EDIT_PAGE_URLS);
exports.closeEditPageUrls = closeEditPageUrls;
var updatePageForUrlEdit = (0, _fluxActions.createAction)(InteractionsActionTypes.UPDATE_PAGE_FOR_URL_EDIT, function (page) {
  return page;
});
exports.updatePageForUrlEdit = updatePageForUrlEdit;
var updateEditPageUrlsTableIndex = (0, _fluxActions.createAction)(InteractionsActionTypes.UPDATE_EDIT_PAGE_URLS_TABLE_INDEX, function (index) {
  return index;
});
exports.updateEditPageUrlsTableIndex = updateEditPageUrlsTableIndex;
var updateDomainForSitemap = (0, _fluxActions.createAction)(InteractionsActionTypes.UPDATE_DOMAIN_FOR_SITEMAP, function (domain) {
  return domain;
});
exports.updateDomainForSitemap = updateDomainForSitemap;
var updateFilterForSitemap = (0, _fluxActions.createAction)(InteractionsActionTypes.UPDATE_FILTER_FOR_SITEMAP, function (filter) {
  return filter;
});
exports.updateFilterForSitemap = updateFilterForSitemap;
var changeSitemapPageForEdit = (0, _fluxActions.createAction)(InteractionsActionTypes.CHANGE_SITEMAP_PAGE_FOR_EDIT, function (page) {
  return page;
});
exports.changeSitemapPageForEdit = changeSitemapPageForEdit;
var updatePagesForSitemapIndex = (0, _fluxActions.createAction)(InteractionsActionTypes.UPDATE_PAGES_FOR_SITEMAP_INDEX, function (pageIndex) {
  return pageIndex;
});
exports.updatePagesForSitemapIndex = updatePagesForSitemapIndex;